import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { CRMParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';
import MaintenanceRequestComponent from '../MaintenanceRequests/MaintenanceRequestComponent';

export default function KanbanMaintenanceRequestDetail({ navigation }: {
    navigation: RootNavigation;
}) {
    const route = useRoute<RouteProp<CRMParamList, 'KanbanMaintenanceRequestDetail'>>();
    return <MaintenanceRequestComponent navigation={navigation} route={route} page={'kanban-maintenance-requests'} />;
}
